import { render, staticRenderFns } from "./UpdateButton.vue?vue&type=template&id=ff437844"
import script from "./UpdateButton.vue?vue&type=script&lang=js"
export * from "./UpdateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports